import React from "react";
import palette from "src/theme/palette";

const RemoveIcon = ({ color = palette.grey[500], size = 20 }) =>
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect width="20" height="20" rx="10" fill={color} />
    <path d="M13 7L7 13M7 7L13 13" stroke="white" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
  </svg>;

export default RemoveIcon;
